
export default {
  
  getRichSnippet(artist, details, url, snippets){
    let ret =  {
      "@context": "http://schema.org/", 
      "@type": "Person", 
      "url": url, 
      "name": artist.formatted_name, 
      "jobTitle": details.subhead, 
      "worksFor": {
        "@type": "Organization", 
        "name": snippets.company	
      }
    }
    if(details.country){
      ret.workLocation =
      {
        "@type": "Place", 
        "address": 
        {
          "@type": "PostalAddress", 
          "addressCountry": details.country
        }
      }
    }
    return ret
  } 
}